<template>
  <div
    id="primaryButton"
    class="focus:shadow-outline transition-200 transition-ease-in-out  relative z-10 inline-block select-none border px-4 py-3 text-center text-xs font-medium uppercase leading-tight tracking-wide transition-all focus:outline-none"
    :class="getClasses()"
    :style="getStyles()"
    @click="emitClick"
  >
    <div
      class="flex h-full w-full justify-evenly text-center"
      :class="loading ? 'opacity-0' : ''"
      style="padding-top: 2px; margin-botton: -2px; margin-top: -2px"
    >
      <span class="flex">
        {{ text }}
      </span>
      <div
        ref="button"
        class="hidden"
      >
        <slot name="svg" />
      </div>
    </div>
    <div class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
      <LoadingSpinner
        v-if="loading"
        :white="true"
        class="-mt-2"
      />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../loadingSpinner.vue';

export default {
  components: {
    LoadingSpinner,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
    textSize: {
      type: String,
      default: 'text-xs ',
    },
    padding: {
      type: String,
      default: 'py-3 px-1 ',
    },
    fullWidthWeb: {
      type: Boolean,
      default: true,
    },
    fullWidthMobile: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    generic: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    customColor: {
      type: String,
      default: 'brand-button',
    },
  },

  computed: {
    isMobile() {
      return this.$isMobile.value || this.$isMobileApp;
    },
  },
  mounted() {
    this.hackClassesIn();
  },

  methods: {
    emitClick(evt) {
      if (!this.loading && !this.disabled) {
        this.$emit('click', evt);
      }
    },

    hackClassesIn() {
      if (this.$refs.button.children.length > 0) {
        this.$refs.button.classList.remove('hidden');
        this.$refs.button.classList.add('flex');
        this.$refs.button.classList.add('items-center');
        this.$refs.button.classList.add('h-full');
        // eslint-disable-next-line no-restricted-syntax
        for (const item of this.$refs.button.children) {
          item.classList.add('h-6');
          item.classList.add('w-6');
          item.classList.add('inline-block');
          item.classList.add('fill-secondary-500');
        }
      }
    },

    getClasses() {
      let classes = `${this.textSize} ${this.padding} `;

      if ((this.fullWidthWeb && !this.isMobile) || (this.fullWidthMobile && this.isMobile)) {
        classes += 'w-full ';
      }

      if (this.loading) {
        classes += 'cursor-wait ';
      } else {
        classes += 'cursor-pointer ';
      }

      if (this.rounded) {
        classes += 'rounded-lg ';
      }

      if (this.disabled) {
        classes += 'bg-gray-200 text-gray-600 ';
      } else if (!this.generic) {
        classes += 'text-white bg-primary-500 hover:bg-primary-400 ';
      } else {
        classes += 'text-white bg-gray-700 hover:bg-gray-600 border-gray-600 ';
      }

      classes += this.customColor;
      return classes;
    },

    getStyles() {
      let styles = '';
      if (this.disabled) {
        styles
          += 'background-color: #E5E7EB !important; color: #4B5563 !important; cursor: default !important; border-color: rgba(0, 0, 0, 0.1) !important; ';
      }

      if (!this.rounded) {
        styles += 'border-radius: 0; ';
      }

      return styles;
    },
  },
};
</script>
